document.addEventListener("DOMContentLoaded", function () {
	$(".image-slider__track").slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 500,
		cssEase: "ease-in-out",
		infinite: true,
		arrows: true,
		dots: false,
		fade: true,
		pauseOnHover: false,
		prevArrow:
			'<button class="image-slider__nav image-slider__nav--prev" aria-label="Previous slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 22" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="11 1 1 11 11 21"></polyline></svg></button>',
		nextArrow:
			'<button class="image-slider__nav image-slider__nav--next" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 22" fill="none" stroke="currentColor" stroke-width="1.5"><polyline points="1 1 11 11 1 21"></polyline></svg></button>',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: true,
					dots: false,
				},
			},
		],
	});
});
